import { Component, Vue, Prop } from 'vue-property-decorator';
import Billing from '@/types/Billing';
import { getLastBillingRequest, createNewBillingRequest } from '@/utils/api';
import * as constants from './constants';

@Component

export default class BillingDetails extends Vue {
    public constants: object = constants;
    public billingDetails: Billing | null = null;
    public billingDetailsError: string | null = null;
    public nextBillingRunError: string | null = null;

    public created() {
        const fetchData = async () => {
            try {
                this.billingDetails = await getLastBillingRequest();
            } catch (error) {
                this.billingDetailsError = 'Failed to load data.';
            }
        };

        fetchData();
    }

    public async handleNextBillingRun() {
        try {
            this.billingDetails = await createNewBillingRequest();
        } catch (error) {
            this.nextBillingRunError = 'Failed to run next billing.';
        }
    }
}
